export const bonusCategories = {
	title: "Categorias de bônus",
};
